const grid = {
    data() {
        return {
            columns: [],

            currentPage: 1,
            pageLength: 25,

            sort: {
                field: '',
                dir: '',
            },

            totalRowsCount: 0,

            selectedRows: [],
            selectedAllResults: false,

            getGridDataMethodName: "getList"
        }
    },

    watch: {
        pageLength() {
            let lastPage = Math.ceil(this.totalRowsCount / this.pageLength)

            if (this.currentPage > lastPage) {
                this.currentPage = lastPage
            }

            this.updateList()
        },
    },

    methods: {
        updateList() {
            this[this.getGridDataMethodName]()
        },

        changePage(page) {
            this.currentPage = page
            this.updateList()
        },

        changeSort(sort) {
            this.sort = sort
            this.updateList()
        },

        changeSelectedRows(ids) {
            this.selectedRows = ids
        },

        selectAllResults(result) {
            this.selectedAllResults = result
        },
    }
}

export default grid
